<div class="notification">
  <mat-icon class="status-icon"
    [ngClass]="notification.level">
    {{getIcon()}}
  </mat-icon>
  <div class="message">
    <div [innerHTML]="notification.message"></div>
    @if (notification.id) {
      <div
        class="mat-small">
        (id: {{notification.id}})
      </div>
    }
  </div>
  <button mat-icon-button
    class="close-button"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
